var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('v-flex',[_c('v-card',[_c('v-toolbar',{attrs:{"color":"white"}}),_c('v-divider'),_c('AdminEditIM',{attrs:{"title":_vm.title,"dialogType":_vm.dialogType}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }